import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Country } from '@app/models/country';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  countries: Country[] = [];
  countries$ = new BehaviorSubject<Country[]>(null);

  constructor(private http: HttpClient) {
  }

  getCountries() {
    return this.http.get<any>(environment.apiUrl + 'Country/GetCountriesAsync');
  }

  setCountryList(countries: Country[]) {
    this.countries$.next(countries);
  }

  getCountryList() {
    return this.countries$.getValue();
  }
}
